export const brand = {
  logo:
    'https://cdn.magicpatterns.com/uploads/kRmLx8szKhTFZPhrukZFJD/ChatGPT_Image_20_sept_2026,_07_14_39_p.m..webp',
  hero:
    'https://cdn.magicpatterns.com/uploads/g83QqC1JqMjz9kD7FaCxat/ChatGPT_Image_20_sept_2026,_07_43_09_p.m..webp',
  founderPortrait:
    'https://cdn.magicpatterns.com/uploads/6qFkH3d1K5bGxAY9SnuLvC/About_us_Yubri.webp',
  shopAllHref: 'https://shop.eloragoldny.com/collections/all',
  phone: '+1 (631) 388-9620',
  email: 'eloragoldny@gmail.com',
  instagram: '@eloragoldny',
  instagramHref: 'https://instagram.com/eloragoldny',
  whatsappHref: 'https://wa.me/16313889620',
  address: '1657 Summerfield St, Ridgewood, NY 11385',
}
